import authService from '@/services/authService';
import {
  destroyToken, destroyUser, getUser, getToken, saveToken, saveUser,
} from '@/services/jwtService';
import {
  LOGIN, LOGOUT, AUTH_REQUEST, AUTH_SUCCESS, AUTH_ERROR, CHECK_AUTH, RELOAD_USER,
} from './actions.type';

const authModule = {
  state: () => ({
    status: '',
    token: '',
    user: {},
  }),
  getters: {
    token: (state) => state.token,
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    user: (state) => state.user,
  },
  actions: {
    async [LOGIN](context, user) {
      context.commit(AUTH_REQUEST);

      const siret = user.username;

      return new Promise((resolve, reject) => {
        authService.login(user)
          .then((resp) => {
            const { token } = resp.data;

            // Décode le JWT (Base64 vers JsonObject) + résolution d'un problème d'encodage UTF-8
            const decodedJwt = JSON.parse(decodeURIComponent(atob(resp.data.token.split('.')[1]).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join('')));

            const authUser = {
              businessName: decodedJwt.sub,
              email: decodedJwt.email,
              siret: siret.split(' ').join(''),
              firstConnexion: resp.data.defaultPassword, // decodedJwt.firstConnexion
            };

            context.commit(AUTH_SUCCESS, { token, user: authUser });
            resolve(authUser);
          })
          .catch((err) => {
            context.commit(AUTH_ERROR);
            reject(err);
          });
      });
    },
    async [LOGOUT]({ commit }) {
      return new Promise((resolve) => {
        commit(LOGOUT);
        resolve();
      });
    },
    async [CHECK_AUTH](context) {
      const token = getToken();
      if (token) {
        if (!context.state.user.siret) {
          context.commit(RELOAD_USER, token);
        }
      } else {
        context.commit(LOGOUT);
      }
    },
  },
  mutations: {
    [AUTH_REQUEST](state) {
      state.status = 'loading';
    },
    [AUTH_SUCCESS](state, { token, user }) {
      state.status = 'success';
      state.token = token;
      state.user = user;
      saveToken(token);
      saveUser(user);
    },
    [AUTH_ERROR](state) {
      state.status = 'error';
    },
    [LOGOUT](state) {
      state.status = '';
      state.token = '';
      state.user = {};
      destroyToken();
      destroyUser();
    },
    [RELOAD_USER](state, token) {
      state.user = getUser();
      state.token = token;
    },
  },
};

export default authModule;
